// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o9-1";
export var messageSideRight = "_o9-2";
export var orderLookupBubbleContainer = "_o9-0";
export var submitButton = "_o9-3";